import { useEffect } from 'react';
import { RadioGroup, useRadioState } from 'reakit';

import { Radio, Row, T8y } from 'ui';

import { ReactComponent as DeliveryIcon } from 'assets/images/icons/delivery.svg';

import style from './deliveryType.module.scss';

export const DeliveryType = ({ setSelectingDetails, isTotalPriceLoading }) => {
  const radioDeliveryType = useRadioState({ state: 'delivery' });

  useEffect(() => {
    setSelectingDetails((prevSate) => ({
      ...prevSate,
      delivery: radioDeliveryType.state,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [radioDeliveryType.state]);

  return (
    <div className={style.deliveryType}>
      <div className={style.deliveryTypeTitle}>
        <DeliveryIcon />
        <T8y xsVariant="t1" color="wilkoBlack" bold>
          Delivery type
        </T8y>
      </div>
      <RadioGroup
        {...radioDeliveryType}
        aria-label="delivery"
        mb
        mt
        className={style.deliverySection}
      >
        <Radio
          {...radioDeliveryType}
          text="Drop off and collect later"
          value="delivery"
          variant="t2v1"
          color="wilkoBlack"
          boldLight
          className={style.deliveryOption}
          circleClassName={style.deliveryOptionCircle}
          circleActiveClassName={style.deliveryActiveOptionCircle}
          disable={isTotalPriceLoading}
        />
        <Radio
          {...radioDeliveryType}
          text="Wait while you load"
          value="waitAndLoad"
          variant="t2v1"
          color="wilkoBlack"
          boldLight
          circleClassName={style.deliveryOptionCircle}
          circleActiveClassName={style.deliveryActiveOptionCircle}
          disable={isTotalPriceLoading}
        />
      </RadioGroup>
    </div>
  );
};
